<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1">
<p class="half">Siege Warfare during the Crusades</p>
</a><a id="VPS-2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Half_title.vue?b8ce3b00